import { createSlice } from '@reduxjs/toolkit';
export const ALERT_MESSAGE_FEATURE_KEY = 'alertMessage';

export interface AlertMessageState {
  textAlert: string;
  typeAlert: 'success' | 'error' | 'warning' | 'info' | 'pending';
  width?: 'full-width' | 'parent-width';
  handleShowExternaly?: boolean;
  show?: boolean;
  setShow?: (show: boolean) => void;
  handlerOnClickTextLink?: () => void;
  textLink?: string;
}
const initialState: AlertMessageState = {
  textAlert: '',
  typeAlert: 'success',
};

export const alertMessageSlice = createSlice({
  name: ALERT_MESSAGE_FEATURE_KEY,
  initialState: initialState,
  reducers: {
    showAlert: (state, action) => {
      state.textAlert = action.payload.textAlert;
      state.typeAlert = action.payload.typeAlert;
      if (action.payload.width) {
        state.width = action.payload.width;
      }
      if (action.payload.show) {
        state.show = action.payload.show;
      }
      if (action.payload.handleShowExternaly) {
        state.handleShowExternaly = action.payload.handleShowExternaly;
      }
      if (action.payload.textLink && action.payload.handlerOnClickTextLink) {
        state.textLink = action.payload.textLink;
        state.handlerOnClickTextLink = action.payload.handlerOnClickTextLink;
      }
    },
    hideAlert: (state) => {
      state.textAlert = '';
      state.typeAlert = 'success';
      state.show = undefined;
      state.width = undefined;
      state.handleShowExternaly = undefined;
      state.textLink = undefined;
      state.handlerOnClickTextLink = undefined;
    },
  },
});
export const alertMessageReducer = alertMessageSlice.reducer;
export const alertMessageActions = alertMessageSlice.actions;
